import React from "react";
import { Helmet } from "react-helmet";

interface SEOProps {
  title?: string;
  description?: string;
  pathname?: string;
  includeStructuredData?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title = "Bearz Landscaping | Professional Landscaping Services",
  description = "Bearz Landscaping provides professional landscaping services including lawn care, garden design, and hardscaping for both residential and commercial properties.",
  pathname = "",
  includeStructuredData = true,
}) => {
  const baseUrl = "https://bearzlandscaping.ca";
  const canonicalUrl = `${baseUrl}${pathname}`;

  // Structured data for local business
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Bearz Landscaping",
    image: "https://bearzlandscaping.ca/bearz_logo.png",
    url: "https://bearzlandscaping.ca",
    telephone: "514-979-8020",
    address: {
      "@type": "PostalAddress",
      streetAddress: "1234 Rue de la Montagne",
      addressLocality: "Montreal",
      addressRegion: "QC",
      postalCode: "H3Z 2Y7",
      addressCountry: "Canada",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: "45.5017",
      longitude: "-73.5673",
    },
    openingHours: "Mo-Fr 08:00-17:00",
    priceRange: "$",
    sameAs: [
      "https://www.facebook.com/bearzlandscaping/",
      "https://instagram.com/bearzlandscaping",
    ],
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      {includeStructuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
